import React from "react";
import logoSrc from "respondology-logo.png";

const RespondologyLogo = ({ children, style, width = "300px" }) => (
  <div className="logo">
    <img alt="Respondology" className="logo-img" src={logoSrc} style={style} />
    <style jsx>{`
      .logo {
        width: ${width};
      }
      .logo-img {
        display: block;
        margin: 0 auto;
        height: 30px;
      }
    `}</style>
  </div>
);

export default RespondologyLogo;
